<template>
  <div class="ds-control ds-navtree ds-tree ds-no-padding" :class="{ 'tree-loaded': !loading, 'has-btns': rowButtons.length > 0 }" v-loading="reloadDataLoading" @mousedown="mouseDownHandler($event)">
    <DsfPanel :hasHeader="hasHeader" class="fit">
      <template v-slot:title>
        {{ label }}
      </template>
      <template v-slot:header-left>
        <slot name="header-left"></slot>
      </template>
      <template v-slot:header-subtitle>
        <slot name="header-subtitle"></slot>
      </template>
      <template v-slot:header>
        <slot name="header"></slot>
      </template>
      <template>
        <div class="searchbox">
          <slot name="search">
            <el-input v-if="openSearchBox" v-model="filterTextVal" :placeholder="inputPlaceholder" @keyup.enter.native="filterText = filterTextVal">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filterText = filterTextVal" title="检索"></i>
            </el-input>
          </slot>
          <slot name="searchboxSolt"></slot>
        </div>
        <DsfVirtualScroll class="ds-tree-box" scroll-y scroll-x>
          <!--加载自定义搜索结果-->
          <el-tree ref="tree2" v-show="$async && searchSqlUrl && filterText" :empty-text="searchLoaded ? '暂无匹配数据' : '数据查询中...'" :default-expand-all="true" :data="searchData" :check-strictly="true" @check-change="checkChange2" @current-change="currNodeChange" v-bind="elTreeAttrsCore">
            <slot slot-scope="{ node }">
              <NavTreeNode :node="node">
                <template #nodeLabel="{ data }">
                  <slot name="nodeLabel" :data="data"></slot>
                </template>
              </NavTreeNode>
            </slot>
          </el-tree>
          <!--正常全量数据-->
          <el-tree
            ref="tree"
            v-show="!$async || !searchSqlUrl || filterText == ''"
            :empty-text="loading ? '数据查询中...' : '暂无数据'"
            :default-expanded-keys="expandedKeys"
            :lazy="$async"
            :filter-node-method="filterNode"
            :check-strictly="checkStrictly"
            @check-change="checkChange"
            @current-change="currNodeChange"
            @node-expand="nodeExpand"
            @node-collapse="nodeCollapse"
            v-bind="elTreeAttrs"
            :draggable="openDraggable"
            @node-drag-start="handleDragStart"
            @node-drag-enter="handleDragEnter"
            @node-drag-leave="handleDragLeave"
            @node-drag-over="handleDragOver"
            @node-drag-end="handleDragEnd"
            @node-drop="handleDrop"
            :allow-drag="allowDrag"
            :allow-drop="allowDrop"
          >
            <slot slot-scope="{ node }">
              <NavTreeNode :node="node">
                <template #nodeLabel="{ data }">
                  <slot name="nodeLabel" :data="data"></slot>
                </template>
              </NavTreeNode>
            </slot>
            <template v-slot:empty>
              <dsf-empty-data v-if="!loading"></dsf-empty-data>
              <span v-if="loading">数据查询中...</span>
            </template>
          </el-tree>
        </DsfVirtualScroll>
      </template>
    </DsfPanel>
  </div>
</template>

<script>
import navTreeNode from "./navTreeNode";
export default dsf.component({
  name: "DsfNavTree",
  ctrlCaption: "导航树",
  mixins: [$mixins.control, $mixins.tree],
  components: {
    NavTreeNode: navTreeNode
  },
  provide() {
    return {
      $buttonOwner: this,
      $navTreeCtrl: this
    };
  },
  design: {
    //组件加载到设计器上时组件高度默认在父容器铺满
    fit: true,
    metadata: {
      isDeep: false,
      create(root) {
        let query = {};
        let searchBox = [],
          attachSearch = [];
        for (let i = 0; i < this.searchInfo.length; i++) {
          let s = this.searchInfo[i];
          let item = null;

          if (s.type == "0") {
            // 检索框
            item = {
              code: s.code,
              operator: s.operation,
              valueKey: "searchValue",
              dataType: s.dataType,
              format: s.format
            };
            searchBox.push(item);
          } else {
            // 附加条件
            item = {
              code: s.code,
              operator: s.operation,
              valueKey: s.code,
              dataType: s.dataType,
              format: s.format
            };
            attachSearch.push(item);
            s.metadata_fullcode = item.code;
          }
        }
        //添加将检索框条件
        let seachBoxitem = { logic: "or", items: [] };
        seachBoxitem.items.push(...searchBox);

        //添加默认附加条件
        let attachSearchItem = { logic: "and", items: [] };
        attachSearchItem.items.push(...attachSearch);

        let searchitems = { logic: "and", items: [] };
        searchitems.items.push(seachBoxitem);
        searchitems.items.push(attachSearchItem);
        // seachBoxitem.items.length > 0 && searchitems.items.push(seachBoxitem);
        // attachSearchItem.items.length > 0 && searchitems.items.push(attachSearchItem);
        query = searchitems;
        let metadata = {
          query: query,
          self: this,
          metadata: this.metadata,
          browseScope: this.browseScope
        };
        if (this.buildMetadata) {
          return [metadata];
        }
        return [];
      }
    }
  },
  props: {
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("nav-tree-meta-data");
      }
      //desc: "元数据",
    },
    label: {
      type: String,
      default: "导航树"
      //desc: "标题",
    },
    inputPlaceholder: {
      type: String,
      default: "请输入查询关键字",
    },
    hasHeader: {
      type: Boolean,
      default: true
      // desc: "显示标题",
    },
    showIcon: {
      type: Boolean,
      default: true
      //desc: "显示节点图标",
    },
    openSearchBox: {
      type: Boolean,
      default: true
      //desc: "启用搜索框",
    },
    disabledBeforeLoaded: {
      type: Boolean,
      default: true
      //desc: "搜索结果加载完成前禁止输入",
    },
    openWebroot: {
      type: Boolean,
      default: false
      //desc: "启用虚拟根目录",
    },
    webrootName: {
      type: String,
      default: ""
      //desc: "虚拟根目录的节点名称",
    },
    targetIframeName: {
      type: String,
      default: ""
      //desc: "跳转iframe的NAME标识",
    },
    targetIframeSrc: {
      type: String,
      default: ""
      //desc: "跳转iframe地址",
    },
    pId: {
      type: String,
      default: ""
      //desc: "根节点数据",
    },
    globalId: {
      type: String,
      default: ""
      //desc: "全局ID",
    },
    maxLevel: {
      type: String,
      default: ""
      //desc: "最大层级",
    },
    defaultOpenSeries: {
      type: String,
      default: "1"
      //desc: "初始化展开至第几级",
    },
    defaultOrder: {
      type: String,
      default: ""
      //desc: "默认排序代码: xx desc,",
    },
    searchInfo: {
      type: Array,
      default() {
        return [];
      }
      //desc: '查询条件,"dsfa_rm.type_value": "0"',
    },
    filterKeyInfo: {
      type: Array,
      default() {
        return [
          {
            code: "_name",
            operation: "like"
          },
          {
            code: "pinyin",
            operation: "slike"
          },
          {
            code: "py",
            operation: "slike"
          }
        ];
      }
    },
    initDataSource: {
      type: String,
      default: "1"
      //desc: "初始化数据来源，1:代表页面元数据，2:代表可选择数据，3:代表自定义接口",
    },
    initDataSourceUrl: {
      type: String,
      default: ""
      //desc: "自定义接口地址",
    },
    asyncUrl: {
      type: String,
      default: ""
      //desc: "异步的自定义接口地址",
    },
    chooseMetaData: {
      type: Object,
      default() {
        return {
          attach: []
        };
      }
      //desc: "初始化选择的数据来源及选择时的具体数据",
    },
    async: {
      type: Boolean,
      default: false
      //desc: "是否启用异步,在初始化数据来源为自定义接口的时候，就算启用也不会生效",
    },
    asyncDataSource: {
      type: String,
      default: "1"
      //desc: "初始化数据来源，1:代表页面元数据，2:代表可选择数据",
    },
    asyncChooseMetaData: {
      type: Object,
      default() {
        return {};
      }
      //desc: "异步请求选择的数据来源及选择时的具体数据",
    },
    metadata_fullcode: {
      type: String,
      default: ""
    },
    browseScope: {
      type: Object,
      default() {
        return {
          scope: "2",
          unit: []
        };
      }
      //desc: "发送范围",
    },
    icons: {
      type: Array,
      default() {
        return [
          {
            code: "!@[children]",
            iconExpand: "icon-shiyongwendang",
            iconFold: "icon-shiyongwendang",
            color: "#6594dc"
          },
          {
            code: "!!@[children]",
            iconExpand: "icon-dakai",
            iconFold: "icon-wenjianjia",
            color: "#c78511"
          }
        ];
      }
      //desc: "图标设置",
    },
    rowButtons: {
      type: Array,
      default() {
        return [];
      }
    },
    renderRowButton: {
      type: Function,
      default: null
    },
    menusButtons: {
      type: Array,
      default() {
        return [];
      }
      //desc: "右键菜单按钮",
    },
    setIframePath: {
      type: Function,
      default: null
    },
    showCheckbox: {
      type: Boolean,
      default() {
        return false;
      }
    },
    checkedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    buildMetadata: {
      type: Boolean,
      default: true
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    initSelectionNode: {
      type: Function,
      default: null
    },
    searchSqlUrl: {
      //自定义搜索地址
      type: String,
      default: ""
    },
    searchPidKey: {
      type: String,
      default: "pid"
    },
    hasPrefix: {
      type: Boolean,
      default: false
    },
    dblclickIsOpen: {
      // 是否双击展开节点
      type: Boolean,
      default: false
    },
    openDraggable: {
      // 是否开启拖拽节点功能
      type: Boolean,
      default: false
    },
    allowDrag: {
      // 判断节点能否被拖拽 Function(node)
      type: Function,
      default() {
        return () => {
          return true;
        };
      }
    },
    allowDrop: {
      // 拖拽时判定目标节点能否被放置 Function(draggingNode, dropNode, type)
      // type 参数有三种情况：'prev'、'inner' 和 'next'，分别表示放置在目标节点前、插入至目标节点和放置在目标节点后
      type: Function,
      default() {
        return () => {
          return true;
        };
      }
    },
    btnUpdated: {
      type: Boolean,
      default: false
    },
    buttonsMaxNumber: {
      type: Number,
      default: 0
    },
    moreBtnColNum: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      metadataFullcode: this.metadata_fullcode,
      expandedKeys: [],
      filterText: "", //点击回车真正的搜索的值
      filterTextVal: "",
      defaultProps: {
        children: "children",
        label: "_name",
        key: "_id",
        isLeaf: "isLeaf"
      },
      data: [],
      resolve: null,
      loading: false,
      currNode: null,
      searchData: [],
      searchLoaded: false,
      searchCheckedNodes: [],
      reloadDataLoading: false
    };
  },
  computed: {
    elTreeAttrsCore() {
      // 两棵树一致的属性
      return {
        props: this.defaultProps,
        class: "filter-tree ds-tree-select-tree-box",
        "default-checked-keys": this.showCheckbox ? this.checkedKeys : [],
        "show-checkbox": this.showCheckbox,
        "check-on-click-node": this.showCheckbox,
        "node-key": "_id",
        "highlight-current": true,
        "expand-on-click-node": false
      };
    },
    elTreeAttrs() {
      // 数据树(不是搜索树)的属性
      let obj = this.elTreeAttrsCore;
      if (this.$async) {
        obj.load = this.lazyLoad;
      } else {
        obj.data = this.data;
      }
      return obj;
    },
    keywords() {
      const keyword = this.filterText.trim();
      if (keyword === "") {
        return [];
      }
      return keyword.split(" ");
    },
    $async() {
      return this.async && !this.isDesign;
    },
    initOpenLevel() {
      return !this.defaultOpenSeries || this.defaultOpenSeries <= 1 ? 1 : this.defaultOpenSeries;
    }
  },
  watch: {
    filterText(val) {
      this.searchLoaded = false;
      this._filter(val);
    },
    // 自定义接口下拉
    initDataSourceUrl() {
      let sourceType = this.initDataSource * 1;
      if (sourceType === 3) {
        this.loadData(true);
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.controlMenu);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.controlMenu);
  },
  created() {
    this.tidyBtn();
    if (!this.isDesign) {
      this.initEventFlow();
    }
    if (this.$vm && this.$vm.isPreView) {
      if (!this.$vm?.nameSpace) {
        this.$vm.nameSpace = ""; //"dsfa.rm";
      }
      if (!this.$vm?.pageName) {
        this.$vm.pageName = ""; //"main";
      }
      this.metadataFullcode = ""; //"dsfa_rm.NavTree4";
    }
    if (!this.$async) {
      this.loadData(true, false);
    }
  },
  methods: {
    mouseDownHandler(evt) {
      // 解决行按钮不消失问题

      // 点击滚动条时不用处理
      if (evt.target?.parentNode?.className?.includes?.("ds-tree-box")) return;
      // 点击当前行的时候不用处理
      if (evt.target?.closest?.(".el-tree-node__content")?.getElementsByClassName?.("custom-tree-node")?.[0]?.__vue__) {
        let treeNode = evt.target?.closest?.(".el-tree-node__content")?.getElementsByClassName?.("custom-tree-node")?.[0]?.__vue__;
        if (treeNode.isMouseEnter && treeNode?.$refs?.btnCtrl && !treeNode?.$refs?.btnCtrl?.moreFold) return;
      }
      document.body.click();
    },
    tidyBtn() {
      if (!this.btnUpdated) {
        let menusButtons = [].concat(this.menusButtons);
        if (this.menusButtons?.length) {
          // 如果之前单独设置了右键菜单按钮，合并的时候需要注意不要重复
          let menusBtnsIds = _.map(menusButtons, (it) => {
            it.isContextmenu = true;
            return it.id;
          });
          _.forEachRight(this.rowButtons, (it, i) => {
            if (menusBtnsIds.includes(it.id)) {
              this.rowButtons.splice(i, 1);
            }
          });
        }
        let rowButtons = [].concat(this.rowButtons, menusButtons);
        _.forEachRight(rowButtons, (it, i) => {
          // 处理按钮样式
          // if(it.isContextmenu){
          //   // 原来的右键菜单按钮
          //   it.type = "";
          //   it.btnStyle = "";
          // }
          if (!it.text) {
            it.text = it.title;
          }
          it.btnStyle_hidden = false;
          it.iconPosition_hidden = false;
          it.text_hidden = false;
          it.type_hidden = false;
        });
        this.$emit("update:btnUpdated", true);
        this.$emit("update:menusButtons", []);
        this.$emit("update:rowButtons", rowButtons);
      }
    },
    initEventFlow() {
      let _this = this;
      this._updatePath = _.throttle(this.__updatePath, 50, {
        leading: false,
        trailing: true
      });
      this._selectedTree = _.throttle(this.__selectedTree, 50, {
        leading: false,
        trailing: true
      });
      this._filter = _.debounce(function (v) {
        if (_this.disabledBeforeLoaded) {
          _this.reloadDataLoading = true;
        }
        _this.filterText = v;
        _this.searchData = [];
        if (_this.$async && _this.searchSqlUrl && v != "") {
          _this.initLoadData(null, true, v);
        } else {
          _this.$refs?.tree.filter(v);
          _this.$nextTick(() => {
            _this.searchLoaded = true;
            _this.reloadDataLoading = false;
          });
        }
      }, 600);
    },
    getTreeNode(node) {
      return this.$refs.tree.getNode(node);
    },
    checkChange2(data, isChecked, node) {
      this.checkChange(data, isChecked, node, true);
    },
    checkChange(data, isChecked, node, isSearch) {
      if (isSearch) {
        this.$refs.tree.setChecked(data._id, isChecked);
        if (isChecked) {
          this.searchCheckedNodes.push(data);
          this.searchCheckedNodes = _.uniqBy(this.searchCheckedNodes, "_id");
        } else {
          _.pullAllBy(this.searchCheckedNodes, [data], "_id");
        }
      }
      let checkedNodes = this.$refs.tree.getCheckedNodes();
      let treeNodes = {};
      let parentIds = [];
      checkedNodes.forEach((node) => {
        // 父节点
        if (node?.children?.length > 0) {
          parentIds.push(node._id);
        }
      });
      checkedNodes = _.uniqBy(checkedNodes.concat(checkedNodes, this.searchCheckedNodes), "_id");
      // 选中了根目录
      if (checkedNodes?.[0]?.pid == "0") {
        const item = checkedNodes[0];
        Object.keys(item).forEach((key) => {
          if (key !== "children") {
            if (!treeNodes[key]) {
              treeNodes[key] = [item[key]];
            } else {
              treeNodes[key].push(item[key]);
            }
          }
        });
      } else {
        checkedNodes?.forEach((item) => {
          if (parentIds.indexOf(item.pid) === -1 || parentIds.indexOf(item._id) > -1) {
            Object.keys(item).forEach((key) => {
              if (key !== "children") {
                if (!treeNodes[key]) {
                  treeNodes[key] = [item[key]];
                } else {
                  treeNodes[key].push(item[key]);
                }
              }
            });
          }
        });
      }    
      if (this.$vm && this.$vm.frames) {
        let view = this.$vm.frames[this.targetIframeName];
        let url = "";
        if (view) {
          if (!this.setIframePath) {
            url = this.$replace(decodeURIComponent(this.targetIframeSrc), this.$expressParams(treeNodes));
          } else {
            url = this.setIframePath(treeNodes, checkedNodes);
          }
          this._updatePath(view, url);
        }
      }
      // ids 如果子节点全部选中 则选中父节点 checkedNodes el-tree选中的数据
      this._selectedTree({
        treeNodes,
        checkedNodes,
        currentNode: data,
        isChecked
      });
    },
    __updatePath(view, url) {
      view.$emit("update:path", url);
    },
    __selectedTree(params) {
      this.$dispatch("selectedTree", params);
    },
    nodeExpand(data) {
      let key = this.defaultProps.key;
      dsf.array.ensure(this.expandedKeys, data[key]);
    },
    nodeCollapse(data, node) {
      let key = this.defaultProps.key;
      dsf.array.remove(this.expandedKeys, data[key]);
      _.each(node.childNodes, (it) => {
        this.nodeCollapse(it.data, it);
      });
    },
    loadData(isInit, isReload) {
      if (this.isDesign) {
        let root = loadDesignerDefaultData.call(this);
        this.data = this.initDataSource == "4" ? this.chooseMetaData.attach || [] : root;
        this.firstLoadedSuccess(false, this.data, isReload);
        _.each(this.data, (it) => {
          this.initExpand(it);
        });
      } else if (this.initDataSource == "4") {
        // 静态数据
        this.searchLoaded = true;
        this.firstLoadedSuccess(false, this.chooseMetaData.attach || [], isReload);
      } else {
        if (isInit) {
          this.initLoadData(null, false);
        } else if (isReload) {
          this.initLoadData(null, true);
        }
      }
    },
    initExpand(node, initLevel) {
      // 初始化展开层级处理
      let key = this.defaultProps.key;
      let children = this.defaultProps.children;
      let nodeLevel = (node["_realLevel"] == undefined ? node["treeinfo_level"] : node["_realLevel"]) * 1;
      nodeLevel = parseInt(nodeLevel);
      initLevel = parseInt(initLevel);
      if (nodeLevel < initLevel) {
        dsf.array.ensure(this.expandedKeys, node[key]);
      }
      if (node[children] && node[children].length > 0) {
        for (let i = 0; i < node[children].length; i++) {
          this.initExpand(node[children][i], initLevel);
        }
      }
    },
    requestTreeData(filterText) {
      return new Promise((resolve, reject) => {
        const self = this;
        self.loading = true;
        let sourceType = this.initDataSource * 1;
        let sourceConfig = this.chooseMetaData;
        let url = "meta/tree";
        let args = {
          pid: self.pId,
          metaFullCode: self.metadataFullcode,
          namespace: self.$vm?.nameSpace,
          pageName: self.$vm?.pageName,
          globalIdValue: self.globalId,
          query: null,
          maxLevel: self.maxLevel || 10,
          order: []
        };
        // let openLevel=!this.defaultOpenSeries || this.defaultOpenSeries <= 1 ? 1 : this.defaultOpenSeries;
        if (self.$async) {
          args.openLevel = this.initOpenLevel;
        }
        if (sourceType === 2 && sourceConfig.type) {
          if (sourceConfig.type == "meta") {
            // 元数据获取树
            args.name = sourceConfig.code.id;
            url = "meta/tree/byName";
          } else if (sourceConfig.type == "static") {
            self.loading = false;
            self.searchLoaded = true;
            self.reloadDataLoading = false;
            return false;
          } else if (sourceConfig.type == "ds") {
            // 数据源获取树
            args = {
              rmId: sourceConfig.code
            };
            url = "meta/tree/dbSource";
          }
        } else if (sourceType === 3) {
          url = self.initDataSourceUrl;
          args = {};
        }

        // 整理查询条件
        let queryData = {
          searchValue: ""
        };
        let searchInfo = self.searchInfo;
        for (let i = 0; i < searchInfo.length; i++) {
          let item = searchInfo[i];
          if (item.type == "1") {
            let arr = item.code.split(".");
            if (arr.length == 2) {
              queryData[item.code] = item.valueExpress;
            } else {
              queryData[item.metadata_fullcode] = item.valueExpress;
            }
          }
        }

        // 整理排序代码
        let defaultOrder = $.trim(self.defaultOrder).split(",");
        for (let i = 0; i < defaultOrder.length; i++) {
          let o = defaultOrder[i];
          let reg = /(.+)\s+(desc|asc)/gim;
          let s = $.trim(o);
          if (s) {
            let result = reg.exec(s);
            if (result) {
              let obj = {
                code: result[1], //list.root.scope + "." + result[1],
                sort: result[2] || "ASC"
              };
              args.order.push(obj);
            }
          }
        }
        args.order = JSON.stringify(args.order);
        args.query = JSON.stringify(queryData);
        if (filterText) {
          args.keyWord = filterText;
        }
        dsf.mix(args, this.queryString);
        if (url) {
          self.$http
            .get(self.$replace(filterText ? self.searchSqlUrl : url, self.$expressParams(self)), args, (!filterText && sourceType !== 3) || self.hasPrefix)
            .done((res) => {
              if (res.success) {
                resolve(res.data);
                // this.firstLoadedSuccess(resolve, res.data, isReload, filterText);
              } else {
                if (!filterText && this.$listeners["initedErr"]) {
                  self.$dispatch("initedErr", res);
                } else {
                  dsf.layer.message(res.message, false);
                }
              }
            })
            .error((res) => {
              if (!filterText && this.$listeners["initedErr"]) {
                self.$dispatch("initedErr", res);
              } else {
                dsf.layer.message(res.message || res.error?.message || "数据获取失败", false);
              }
            })
            .always(() => {
              self.searchLoaded = true;
              self.loading = false;
              self.reloadDataLoading = false;
            });
        } else {
          self.loading = false;
          self.reloadDataLoading = false;
        }
      });
    },
    initLoadData(resolve, isReload, filterText) {
      this.requestTreeData(filterText).then((data) => {
        this.firstLoadedSuccess(resolve, data, isReload, filterText);
      });
    },
    firstLoadedSuccess(resolve, list, isReload, filterText) {
      let tree = [],
        virtualRoot = null,
        self = this;
      if (!Array.isArray(list)) {
        list = [list];
      }
      if (isReload) {
        self.expandedKeys = [];
      }
      list = loopSimpleNodes(list, this);
      if (self.openWebroot && !!self.webrootName) {
        virtualRoot = {
          [self.defaultProps.key]: "virtualRoot",
          [self.defaultProps.label]: self.webrootName,
          [self.defaultProps.children]: tree,
          _realLevel: 1,
          children: [],
          _loaded: true
        };
      }
      deepCreateNodeData(list, (it, level, index) => {
        it._realLevel = level + 1 + (virtualRoot ? 1 : 0);
        let isChild = it.children && it.children.length > 0;
        it._loaded = !!isChild;
        if (self.$async) {
          if (self.searchSqlUrl && filterText) {
            if (!isChild) {
              it.isLeaf = true;
            }
          } else {
            it.isLeaf = it.isLeaf || false;
          }
        }
        if (level == 0) {
          tree.push(it);
        }
      });
      if (!filterText) {
        //搜索的时候全展开
        if (virtualRoot) {
          virtualRoot.children.push(...tree);
          this.initExpand(virtualRoot, this.initOpenLevel);
          tree = [virtualRoot];
        } else {
          _.each(tree, (it) => {
            this.initExpand(it, this.initOpenLevel);
          });
        }
      }
      if (filterText) {
        self.searchData = tree;
        self.searchLoaded = true;
        self.$nextTick(() => {
          self.$refs.tree2.setCheckedKeys(
            [].concat(
              self.$refs.tree.getCheckedKeys(),
              _.map(self.searchCheckedNodes, (d) => {
                return d._id;
              })
            )
          );
        });
      } else {
        self.data = tree;
        let choosedNode = tree[0] || {};
        self.$nextTick(() => {
          // 默认选中第一个节点
          // self.loadIframe(choosedNode);
          if (!isReload) {
            let nodeKey = "";
            if (this.initSelectionNode) {
              nodeKey = this.initSelectionNode(tree);
            } else {
              nodeKey = choosedNode[self.defaultProps.key];
            }
            let node = self.$refs.tree?.getNode(nodeKey);
            if (node) {
              this.setCurrentKey(nodeKey);
              self.loadIframe(node.data, node);
              self.currNode = node.data;
            } else {
              dsf.warn("节点无法再树结构中查询到，未能选中");
            }
          } else {
            self.$refs.tree?.setCurrentKey(this.currNode._id);
            this.setCurrentKey(this.currNode._id);
          }
          self.$dispatch("inited", tree);
        });
        if (resolve) {
          return resolve(tree);
        }
      }
    },
    asyncLoadData(node, resolve, isReload) {
      const self = this;
      let args = {},
        currentParentNode = node,
        url = "meta/tree/child";
      if (self.asyncDataSource * 1 === 3) {
        url = self.$replace(self.asyncUrl, self.$expressParams(self, node.data));
        args = {
          [self.searchPidKey]: node.data[self.defaultProps.key]
        };
        // 自定义接口只提供一个必须要的参数，其余可以自写参数例如
        //"...?metaFullCode=@[metadataFullcode]&namespace=@[$vm.nameSpace]"
      } else {
        args = {
          metaFullCode: self.metadataFullcode,
          namespace: self.$vm?.nameSpace,
          pageName: self.$vm?.pageName,
          maxLevel: self.maxLevel || 10,
          pid: node.data[self.defaultProps.key]
        };
      }
      dsf.mix(args, this.queryString);
      self.$http
        .get(self.$replace(url, self.$expressParams(self, currentParentNode.data)), args, true)
        .done((res) => {
          if (res.success) {
            let list = res.data,
              tree = [];
            if (list.children) {
              list = list.children;
            }
            list = loopSimpleNodes(list, this);
            deepCreateNodeData(list, (it, level, index, parentNode) => {
              it._realLevel = parentNode ? parentNode._realLevel : currentParentNode._realLevel;
              let isChild = it.children && it.children.length > 0;
              it._loaded = !!isChild;
              it.isLeaf = it.isLeaf || false;
              if (level == 0) {
                tree.push(it);
              }
            });
            if (resolve) {
              resolve(tree);
            }
            this.$nextTick(() => {
              self.$dispatch("nodes-loaded", tree);
            });
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((res) => {
          dsf.layer.message(res?.error?.message || "服务器异常", false);
        });
    },
    lazyLoad(node, resolve, isReload) {
      if(!node?.data?.isLeaf || isReload){
        this.resolve = resolve;
        if (node.level === 0) {
          this.initLoadData(resolve, isReload);
        } else {
          if (!node.data._loaded) {
            // node.isLeaf = true;
            this.asyncLoadData(node, resolve, isReload);
          } else {
            resolve(node.data.children);
          }
        }
      }else{
        resolve([])
      }
    },
    filterNode(value, data, node) {
      if (!value) return true;
      for (let i = 0; i < this.keywords.length; i++) {
        let key = this.keywords[i]?.toLowerCase();
        for (let j = 0; j < this.filterKeyInfo.length; j++) {
          let state = false;
          let obj = this.filterKeyInfo[j];
          let val = data[obj.code];

          if (!dsf.isUnDef(val)) {
            val = (val + "").toLowerCase();
            let index = val.indexOf(key);
            let op = obj.operation;
            switch (op) {
            case "like": //模糊匹配
              state = index > -1;
              break;
            case "slike": //开头匹配
              state = index == 0;
              break;
            case "elike": //结尾匹配
              state = index + key.length == (val + "").length;
              break;
            case "eq": //等于
              state = val == key;
              break;
            case "noteq": //不等于
              state = val != key;
              break;
            case "lt": //小于
              state = val < key;
              break;
            case "gt": //大于
              state = val > key;
              break;
            case "lteq": //小于等于
              state = val <= key;
              break;
            case "gteq": //大于等于
              state = val >= key;
              break;
            }
          }
          if (state) return true;
        }
      }
      return false;
    },
    currNodeChange(data, node) {
      // 多选不切换iframe
      let key = this.defaultProps.key;
      if (data[key] !== this.currNode?.[key]) {
        this.currNode = data;
        if (!this.showCheckbox) {
          this.loadIframe(data, node);
        }
        this.$dispatch("currNodeChange", { data, node });
      } else {
        this.$dispatch("nodeClick", { data, node });
      }
    },
    loadIframe(data, node) {
      if (this.$vm && this.$vm.frames) {
        let view = this.$vm.frames[this.targetIframeName];
        let url = "";
        if (view) {
          if (!this.setIframePath) {
            url = decodeURIComponent(this.targetIframeSrc);
            url = this.$replace(url, this.$expressParams(this, data));
          } else {
            url = this.setIframePath(data, node);
          }

          view.$emit("update:path", url);
        }
      }
    },
    reloadData() {
      this.data = [];
      if (this.$async && this.resolve) {
        // 异步为单节点刷新
        let tree = this.$refs.tree;
        let currNode = tree.getNode(this.currNode);
        if (currNode) {
          if (currNode.childNodes && currNode.childNodes.length) {
            // 说明原来有数据需要清空
            tree.updateKeyChildren(currNode.key, []);
          }
          currNode.loaded = false;
          currNode.loading = true;
          currNode.data._loaded = false;
          this.lazyLoad(currNode, (data) => {
            tree.updateKeyChildren(currNode.key, data);
            if(data?.length){
              currNode.isLeaf = false;
            }else{
              currNode.isLeaf = true;
            }
            currNode.loaded = true;
            currNode.loading = false;
            currNode.data._loaded = true;
          },true);
        }
      } else {
        this.reloadDataLoading = true;
        this.requestTreeData()
          .then((data) => {
            this.firstLoadedSuccess(null, data, true, null);
            this.$nextTick(() => {
              this.$refs.tree.filter(this.filterText);
              this.$refs.tree.setCurrentKey(this.currNode._id);
            });
          })
          .catch((ex) => {
            dsf.layer.message(ex.message || "数据获取失败", false);
          })
          .finally(() => {
            this.reloadDataLoading = false;
          });
      }
    },
    extendSelectionNode(nodeKey) {
      let node = this?.$refs?.tree?.getNode?.(nodeKey);
      if (node) {
        let key = this.defaultProps.key;
        dsf.array.ensure(this.expandedKeys, node.data[key]);
        if (node.parent && node.parent.data) {
          this.extendSelectionNode(node.parent.data[key]);
        }
      }
    },
    //勾选节点
    setCheckedKeys(node, checked, deep = true) {
      this?.$refs?.tree?.setCheckedKeys?.(node, checked, deep);
    },
    //选中节点
    setCurrentKey(key, isAutoExtend = true) {
      this.$refs.tree?.setCurrentKey?.(key);
      if (isAutoExtend) {
        this.extendSelectionNode(key);
      }
    },
    setAsyncUrl() {
      // 当开启异步时，且异步数据来源是自定义接口时，异步自定义接口为空时，默认为初始化自定义接口
      let initUrl = this.initDataSourceUrl;
      if (initUrl && this.initDataSource === "3" && this.async && this.asyncDataSource === "3" && this.asyncUrl === "") {
        this.asyncUrl = initUrl;
      }
    },
    // --drag event --start
    handleDragStart(node, ev) {
      // 节点开始拖拽时触发的事件
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // 拖拽进入其他节点时触发的事件
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // 拖拽离开某个节点时触发的事件
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // 在拖拽节点时触发的事件（类似浏览器的 mouseover 事件）
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // 拖拽结束时（可能未成功）触发的事件
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // 拖拽成功完成时触发的事件
      this.$dispatch("handleDrop", arguments);
    }
    // --drag event --end
  }
});

function loopSimpleNodes(list, vm) {
  let tree = [],
    temp1 = {};
  for (let i = 0; i < list.length; i++) {
    let node = list[i];
    temp1[node[vm.defaultProps.key]] = node;
    if (temp1[node.treeinfo_pid]) {
      if (!temp1[node.treeinfo_pid]["children"]) {
        temp1[node.treeinfo_pid]["children"] = [];
      }
      temp1[node.treeinfo_pid]["children"].push(node);
    } else {
      tree.push(node);
    }
  }
  return tree;
}

function deepCreateNodeData(data, callback) {
  dsf.deepForEach(
    data,
    (it, level, index, parentObj) => {
      if (self.$async) {
        it.isLeaf = true;
      }
      callback && callback(it, level, index, parentObj);
    },
    { children: "children" }
  );
}
function loadDesignerDefaultData() {
  let designerData = [
    {
      [this.defaultProps.key]: 1,
      [this.defaultProps.label]: "一级",
      [this.defaultProps.children]: [
        {
          [this.defaultProps.key]: 2,
          [this.defaultProps.label]: "二级 1-1",
          icon: "el-icon-info"
        },
        {
          [this.defaultProps.key]: 3,
          [this.defaultProps.label]: "二级 1-2",
          icon: "el-icon-info"
        }
      ]
    }
  ];
  return designerData;
}
</script>
